import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=12029db4&scoped=true&"
import script from "./AddNewDeposit.vue?vue&type=script&lang=js&"
export * from "./AddNewDeposit.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=12029db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12029db4",
  null
  
)

export default component.exports